import { computed, Injectable, signal } from '@angular/core';
import { Router } from '@angular/router';
import { Text } from '../enums/textEnum';

@Injectable({
  providedIn: 'root',
})
export class CommonService {
  private _sidebarHidden = signal(false); // Open by default (sticky)

  constructor(private router: Router) {}

  sidebarHidden = computed(() => this._sidebarHidden());

  toggleSidebar() {
    this._sidebarHidden.set(!this._sidebarHidden());
  }

  openSidebar() {
    this._sidebarHidden.set(false);
  }

  closeSidebar() {
    this._sidebarHidden.set(true);
  }

  public get Text(): typeof Text {
    return Text;
  }

  isAuthCallbackRoute(): boolean {
    return this.router.url.includes('auth_token') && this.router.url.includes('feed_token') && this.router.url.includes('refresh_token') && this.router.url.startsWith('/dashboard?');
  }
}
